import { useQuery } from '@tanstack/react-query'

import { checkPurchasedBooksApi } from '@!/Api/user'
import { userCheckPurchasedBookKeys } from '@!/Api/queryKeys'
import { sliceByNumber } from '@!/lib/array'
import { isBlank } from '@!/Util'

export const useCheckPurchasedBooks = (userHash, contentIds) => {
  return useQuery({
    queryKey: userCheckPurchasedBookKeys.check(userHash, contentIds),
    queryFn: async () => {
      // 414 URI Too Large は2000文字程度で発生する(サーバーの設定による)
      // 50件ずつ程度の取得にとどめる
      const splitedContentIds = sliceByNumber(contentIds, 50)
      const purchasedIds = await Promise.all(splitedContentIds.map(async (ids) => await checkPurchasedBooksApi(ids)))
      return purchasedIds.flat()
    },
    enabled: !!userHash && !isBlank(contentIds),
  })
}
